/* eslint-disable no-unused-vars */
import { RefObject, useRef } from 'react'
import { useGSAP } from '@gsap/react'

import { useLenis } from '@/contexts/lenis'
import { isTouch } from '@/utils/device'

import { Animation } from '@/types'

type MotionProps = {
  children: (ref: RefObject<HTMLDivElement>) => React.ReactNode
  animation: (props: Animation<HTMLElement>) => (() => void) | void // gsap.core.Timeline
  nodeRef?: RefObject<HTMLElement>
  revertOnUpdate?: boolean
}

const Motion = ({
  nodeRef,
  children,
  animation,
  revertOnUpdate = true
}: MotionProps) => {
  const root = useRef<HTMLDivElement>(null!)
  const { lenis } = useLenis()

  useGSAP(
    (context) => {
      if (!lenis) return

      const revert = animation({
        node: root.current,
        mobile: isTouch,
        reverse: false,
        nodeRef,
        context
      })

      return () => {
        if (revert) {
          revert()
        }
      }
    },
    {
      dependencies: [lenis],
      scope: nodeRef || root,
      revertOnUpdate
    }
  )

  return children(root)
}

export default Motion
